var USER_AVATAR_PREFERENCE = {
    PROFILE_PICTURE: "PROFILE_PICTURE",
    NAME_INITIALS: "NAME_INITIALS",
    NONE: "NONE",
};

export { USER_AVATAR_PREFERENCE };
//# sourceMappingURL=CommenterImg.constants.js.map
